'use client'

import React, { useState } from 'react'
import { ChevronDown } from 'lucide-react'

interface FaqItem {
  question: string
  answer: string
}

interface FaqAccordionProps {
  title?: string | null
  items: FaqItem[]
}

export function FaqAccordion({ title, items }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (
    <div className="my-8">
      {title && (
        <h3
          id={title.toLowerCase().replace(/\s+/g, '-')}
          className="text-xl md:text-2xl font-medium text-gray-900 mb-6"
        >
          {title}
        </h3>
      )}
      <div className="divide-y divide-gray-200 border-y border-gray-200">
        {items.map((item, index) => (
          <div key={index}>
            <button
              type="button"
              onClick={() => toggle(index)}
              className="w-full flex items-center justify-between py-5 text-left gap-4 group"
              aria-expanded={openIndex === index}
            >
              <span className="text-base md:text-lg font-medium text-gray-900 group-hover:text-brand-gold transition-colors">
                {item.question}
              </span>
              <ChevronDown
                className={`w-5 h-5 text-gray-500 shrink-0 transition-transform duration-200 ${
                  openIndex === index ? 'rotate-180' : ''
                }`}
              />
            </button>
            <div
              className={`overflow-hidden transition-all duration-200 ${
                openIndex === index ? 'max-h-250 pb-5' : 'max-h-0'
              }`}
            >
              <p className="text-base text-gray-700 leading-relaxed pr-8">{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
